import { render } from "./TipTapOCSI.vue?vue&type=template&id=62621bee&scoped=true"
import script from "./TipTapOCSI.vue?vue&type=script&lang=js"
export * from "./TipTapOCSI.vue?vue&type=script&lang=js"

import "./TipTapOCSI.vue?vue&type=style&index=0&id=62621bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62621bee"]])

export default __exports__